import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddNewVendorComponent } from 'src/app/Product/add-new-vendor/add-new-vendor.component';
import { LoginService } from 'src/app/_services/login.service';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/_alert';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { VendorService, vendorData } from 'src/app/_services/vendor.service';
import { CommonService } from 'src/app/_services/common.service';
import { Subscription } from 'rxjs';
import { MailComponent } from '../popup/mail/mail.component';
import { ActiveVendorComponent } from '../popup/active-vendor/active-vendor.component';

@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrls: ['./vendors.component.css']
})
export class VendorsComponent implements OnInit {
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  dataa: vendorData[] = [];
  @ViewChild(MatPaginator) private paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public dataSource = new MatTableDataSource(this.dataa);
  private subscription: Subscription;
  isLoading: boolean = false;

  public displayedColumns: string[] = ['srNo', 'vendorId', 'email', 'phone', 'status', 'editDetails'];

  constructor(public dialog: MatDialog,
    private alertService: AlertService,
    public commonService: CommonService,
    private vendorService: VendorService,
    private _liveAnnouncer: LiveAnnouncer) {
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit(): void {
    this.allVendors('');
    this.subscription = this.commonService.refreshGrid$.subscribe((refresh) => {
      if (refresh) {
        this.allVendors('');
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  allVendors(custId: string) {
    this.isLoading = true;
    this.vendorService.allVendors(custId).subscribe((response: any[]) => {
      this.dataa = response;
      this.dataSource.data = this.dataa;
      console.table(this.dataa);
      this.isLoading = false;
    },
      (err) => {
        console.log(err);
        this.alertService.error(err.error.errors.Messages[0], this.options);
        this.isLoading = false;
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(AddNewVendorComponent, {
      maxWidth: 'auto',
      width: '550px',
      height: 'auto',
      panelClass: 'custom-dialog',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  deleteVendors(vendorRegistrationId) {
    this.vendorService.deleteVendor(vendorRegistrationId)
      .subscribe((response) => {
        this.commonService.reloadComponent(true);
        console.log(response);
      })
    this.alertService.warn('Vendor Deleted SuccessFully.', this.options);
  }

  announceSortChange(sortState: Sort) {
    console.log('fired vendor');
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }


  //vendor login access
  vendorLoginAccess(vendorData) {
    this.vendorService.vendorLoginAccess(vendorData.vendorId, vendorData.isVendorLogin).subscribe((response) => {
      console.log(response);
      if (vendorData.isVendorLogin == true) {
        this.dialog.open(MailComponent, {
          disableClose: true,
        });
      }
    },
      (err) => {
        console.log(err);
        if (vendorData.isVendorActive == false) {
          this.dialog.open(ActiveVendorComponent,
            {
              disableClose: true,
            })
        }
        vendorData.isVendorLogin = !vendorData.isVendorLogin;
        // this.dialog.closeAll()
      })
  }
}
